import { Money } from './money';
import { Expense as T, Category } from '../Interfaces';

export class Expense extends Money implements T {
    expense_id: number;
    constructor(json?: T,
        public category?: Category,
        public type_data?: any
    ) {
        super(json, category, type_data);
    }
    get id() {
        return this.expense_id;
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/Classes/expense.ts